import { Grid, Modal, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import { PrimaryButton } from './buttons';
var useStyles = makeStyles(function () {
  return {
    modalRoot: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    modalBackdrop: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    modalContent: {
      background: '#fff',
      padding: '2rem',
      borderRadius: 8,
      maxWidth: "600px",
      width: '90%',
      outline: 'none'
    },
    modalHeader: {
      fontWeight: 700,
      fontFamily: "Barlow",
      fontSize: '24px'
    },
    modalText: {
      fontSize: '16px',
      fontWeight: 400,
      fontFamily: "Barlow"
    },
    closeBtn: {
      textTransform: "none",
      backgroundColor: "#0C2340",
      color: "#fff",
      fontWeight: 400,
      fontFamily: "Barlow",
      fontSize: "16px",
      padding: "0 20px",
      borderRadius: "40px",
      '&:hover': {
        backgroundColor: '#123a6bff'
      },
      "& .MuiButton-label": {
        padding: "5px 20px",
        fontSize: "16px"
      }
    }
  };
});
var SignUpModal = function SignUpModal(_ref) {
  var open = _ref.open,
    setOpen = _ref.setOpen;
  var classes = useStyles();
  return React.createElement(React.Fragment, null, React.createElement(Modal, {
    open: open,
    onClose: function onClose() {
      return setOpen(false);
    },
    className: classes.modalRoot,
    BackdropProps: {
      className: classes.modalBackdrop
    }
  }, React.createElement("div", {
    className: classes.modalContent
  }, React.createElement(Grid, {
    container: true,
    spacing: 2
  }, React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      padding: "8px 8px 0px 8px"
    }
  }, React.createElement(Typography, {
    className: classes.modalHeader,
    variant: "h6",
    align: "left"
  }, "VA Account Creation")), React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(Typography, {
    variant: "body1",
    align: "left",
    className: classes.modalText
  }, "Thank you for your interest in genetic testing with Baylor Genetics.", React.createElement("p", null, "As a VA employee, access requests must be submitted through the National Precision Oncology Program (NPOP), not Baylor.", React.createElement("p", null, "Please complete the ", React.createElement("a", {
    href: 'https://nam12.safelinks.protection.outlook.com/?url=https%3A%2F%2Fforms.office.com%2Fpages%2Fresponsepage.aspx%3Fid%3DIxtf6a-r7kWCHberJRqzv7xvk8gnBLhFs9GxihfBEZxUOElVNVZKWERNNFFCTzRHODlRNzE3QzlZRSQlQCN0PWcu%26route%3Dshorturl&data=05%7C02%7Cdghorayeb%40baylorgenetics.com%7C4f33c63be6f0422d356b08ddc97318d7%7Cc1200b99294a4d1d9ab368755381744e%7C0%7C0%7C638888218398400213%7CUnknown%7CTWFpbGZsb3d8eyJFbXB0eU1hcGkiOnRydWUsIlYiOiIwLjAuMDAwMCIsIlAiOiJXaW4zMiIsIkFOIjoiTWFpbCIsIldUIjoyfQ%3D%3D%7C0%7C%7C%7C&sdata=5mmx7E2NIwle2CWCiYCyhJV0yV0DV19y%2B8qTjIQB3TE%3D&reserved=0',
    style: {
      textDecoration: "underline"
    }
  }, "Baylor Genetics Portal Request Form "), "via NPOP procedures.")), React.createElement("p", {
    style: {
      marginBottom: 0
    }
  }, "For questions about access, contact  ", React.createElement("a", {
    href: "mailto:NPOP@va.gov",
    style: {
      textDecoration: "underline"
    }
  }, "NPOP@va.gov")))), React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "flex-end"
    }
  }, React.createElement(PrimaryButton, {
    variant: "contained",
    onClick: function onClick() {
      return setOpen(false);
    },
    className: classes.closeBtn
  }, "Close")))))));
};
export default SignUpModal;